import { render, staticRenderFns } from "./userMGT-whiteOrBlack-edit.vue?vue&type=template&id=2d47fa9e&scoped=true&"
import script from "./userMGT-whiteOrBlack-edit.vue?vue&type=script&lang=js&"
export * from "./userMGT-whiteOrBlack-edit.vue?vue&type=script&lang=js&"
import style0 from "./userMGT-whiteOrBlack-edit.vue?vue&type=style&index=0&id=2d47fa9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d47fa9e",
  null
  
)

export default component.exports